<div class="flex align-items-center gap-2">
  <div *ngFor="let checkbox of checkboxes" class="genderCheckbox">
    <input type='checkbox' id='{{checkbox.label}}' class=' {{checkbox.label}}' name='checkbox' [(ngModel)]="checkbox.checked" (change)="onCheckboxChange()">
    <label for='{{checkbox.label}}'>{{checkbox.label}}</label>
  </div>

</div>
